// ##########################################################################################
// Gallery Entry Block Manager
// ==========================================================================================
// The Entry Block Manager object, defined by the return value of the function below, is a
// submodule of the JDA gallery module. This submodule is responsible for managing the
// behaviour of each individual HTML entry block.
// Specifically:
// ---- Adjusting the height of the blocks, to ensure they remain at a 16:9 aspect ratio.
//      In the context of other visual effects present on the blocks,
//      this cannot be done with CSS alone.
// ---- Controlling what happens when the user makes a touch gesture or mouse gesture
//      on each block.
// ---- Disabling blocks when they are not in the viewport to conserve memory. (And then
//      re-enabling them when they come into view once again) - AKA "Dehydrating" and
//      "rehydrating".
// ##########################################################################################

var galleryModule = app.mediator.getModule(MODULE_NAME__GALLERY);
galleryModule.injectSubModule('entryBlockManager', function() {

    var hideDescriptionTimeout;
    var showDescriptionTimeout;
	var helpers = app.helpers.funcs;

	// =======================================================================
	// Items
	// =======================================================================

    function adjustAllBlocks() {
        var $rootElem = galleryModule.getRootElem();
        var blockSelector = galleryModule.getSelectorClass('entryBlock');
        var $blocks = $rootElem.find('.' + blockSelector);
        adjustBlocks($blocks);
    }

    function adjustBlocks($blocks) {
		$blocks.each(function(blockKey, block) {
			adjustBlock($(block));
		});
    }

	// =======================================================================
	// Item
	// =======================================================================

    function adjustBlock($block) {

        var $rootElem = galleryModule.getRootElem();
        var blockSelector = galleryModule.getSelectorClass('entryBlock');

        // By basing all of our derived ratios on the dimensions of the first block,
        // we avoid "1px issues" that arise from slight variations.
        var $firstBlock = $rootElem.find('.' + blockSelector + ':first');

        var blockWidth = $firstBlock.width();
        var blockHeight = Math.round((blockWidth / 16) * 9);
        var elements = [
            $block,
            $block.find('.item-bg'),
            $block.find('.item-focusring'),
            $block.find('.featured-block-gradient')
        ];
        elements.forEach(function($element) {
            $element.css({
                height: blockHeight + 'px'
            });
        });
    }

	function showDescriptionForBlock($block) {

        // Stop hide
        clearTimeout(hideDescriptionTimeout);
        $block.data('mouseop', 'in');

        // Vars
        var $descrInner = $block.find('.descr-inner');
        var height = parseInt($block.css('height'));

        // Abort if x
        if ($('body').hasClass('touchSupported') || height) return;

        // Adust classes
        $descrInner.removeClass('hiding');
        $descrInner.removeClass('hidden');
        $descrInner.addClass('showing');

        // Animate
        showDescriptionTimeout = setTimeout(function () {
            $descrInner.removeClass('showing');
            $descrInner.removeClass('hidden');
            $descrInner.addClass('shown');
        }, 300);
        $block
            .stop()
            .css({ height: 0 })
            .animate({
                height: $block.attr('data-original-height')
            }, 500, 'easeInOutQuart', function () {
                if ($block.data('mouseop') == 'out') {
                    hideDescriptionForBlock($block);
                    $block.data('mouseop', false);
                }
            });
	}

	function hideDescriptionForBlock($block) {

        // Vars
        var $descrInner = $block.find('.descr-inner');
        $block.data('mouseop', 'out');

        // Abort if transition is already happening
        if ($descrInner.hasClass('hiding') || $descrInner.hasClass('showing')) return;

        // Adjust classes
        $descrInner.removeClass('showing')
        $descrInner.removeClass('shown');
        $descrInner.addClass('hiding')

        // Animate
        hideDescriptionTimeout = setTimeout(function () {
            $descrInner.removeClass('hiding')
            $descrInner.removeClass('shown')
            $descrInner.addClass('hidden');
        }, 500);
        $block.stop().animate({
            height: 0
        }, 500, 'easeInOutQuart', function () {
            if ($block.data('mouseop') == 'in') {
                showDescriptionForBlock($block);
                $block.data('mouseop', false);
            }
        });
	}

    function logOriginalBlockHeight($block) {
        var $description = $block.find('.descr');
        $description.css({
            top: '9999px',
            position: 'relative',
            height: 'auto'
        });
        var oldHeight = $description.height();
        $description.attr('data-original-height', $description.height());
        $description.css({
            top: 0,
            position: 'relative',
            height: 0
        });
    }

    function initialiseBlock($block) {
        logOriginalBlockHeight($block);
        adjustBlock($block);
    }

    // Returns the height that a ".featured-block" is assumed to be,
    // if we can't determine it by inspecting one on the page.
    var blockHeightCachedValue = null;
    var blockHeightLastCalculatedAt = null;
    function getBlockHeight() {
        
        // The maths used in this algorithm derive the height of the block,
        // based on its width, and the knowledge that:
        // 1. It should have a 16:9 aspect ratio.
        // 2. The gallery one item wide on mobile, and two items wide on bigger breakpoints.
        function calculateHeight() {
            var $rootElem = galleryModule.getRootElem();
            var $firstBlock = $rootElem.find(galleryModule.getSelectorClass('entryBlock') + ':first');
            if ($firstBlock.length) return $firstBlock.outerHeight();
            var breakpoint = helpers.getScreenSize();
            var value;
            switch (breakpoint) {
                case app.helpers.screenBreakpoints.xs:
                    value = ($rootElem.width() / 16) * 9;
                    break;
                default:
                    value = (($rootElem.width() / 2) / 16) * 9;
            }
            return parseInt(value);
        }

        // If the blocks calculated height was last worked out over 0.2 seconds ago,
        // go ahead and recalculate the height again.
        if (blockHeightLastCalculatedAt === null || blockHeightLastCalculatedAt < (new Date()).getTime() - 200) {
            blockHeightLastCalculatedAt = (new Date()).getTime();
            blockHeightCachedValue = calculateHeight();
        }

        // Return the (potentially recalculated) height.
        return blockHeightCachedValue;
    }

	// =======================================================================
	// Templating
	// =======================================================================

    // Grabs a copy of the html inside #mod-gallery-item-template,
    // and replaces the dynamic parts (heading, descr, background image)
    // with the content that is supplied in the itemData object.
    function getBlockHtml(itemData) {
        if (!galleryModule.getSubModule('dataManager').itemDataAdheresToInterface(itemData)) {
            throw 'Item data does not adhere to interface!';
        }
        var blockIdx = galleryModule.getSubModule('appendManager').getNumberOfItemsInTheDom() + 1;
        var itemInner = helpers.getTemplateHtml($('#mod-gallery-item-template').get(0)).querySelectorAll('.template-inner');
        var itemHtml = $('<div>').append($(itemInner).clone()).html();
        var $templateHtml = $(itemHtml);
        var ariaLabel = [itemData.name];
        if (itemData.description) ariaLabel.push(itemData.description);
        if (itemData.badge && itemData.badge !== 'null') {
            $templateHtml.find('.item-banner').html(itemData.badge).removeClass('hidden');
            ariaLabel.push(itemData.badge);
        } else {
            $templateHtml.find('.item-banner').html('').addClass('hidden');
        }
        var ariaLabelString = (ariaLabel.join('. ') + '.').replace(/\.\./g, '.');
        $templateHtml.find('a')
            .attr('href', itemData.projectUrl)
            .attr('aria-label', itemData.description)
            .attr('id', 'project-entry-' + (blockIdx))
            .attr('aria-label', ariaLabelString)
            .attr('data-entry-id', itemData.id)
        if (itemData.nameTruncated && itemData.nameTruncated.length > 0) {
            $templateHtml.find('.item-content h2').html(itemData.nameTruncated);
        } else {
            $templateHtml.find('.item-content h2').html(itemData.name);
        }

        if (itemData.descriptionTruncated && itemData.descriptionTruncated.length > 0) {
            $templateHtml.find('.item-content .descr-inner').html(itemData.descriptionTruncated);
        } else {
            $templateHtml.find('.item-content .descr-inner').html(itemData.description);
        }

        if (itemData.imageUrl) {
            $templateHtml.find('.project-image').css({
                backgroundImage: 'url(' + itemData.imageUrl + '?width=720)'
            });
        } else {
            $templateHtml.find('.project-image').css({
                backgroundImage: 'none'
            });
        }
        return $templateHtml;
    }

	// =======================================================================
	// Public API
	// =======================================================================

	return {
        getBlockHtml: getBlockHtml,
        showDescriptionForBlock: showDescriptionForBlock,
        hideDescriptionForBlock: hideDescriptionForBlock,
        adjustAllBlocks: adjustAllBlocks,
        initialiseBlock: initialiseBlock,
        getBlockHeight: getBlockHeight
	};
});